import React, {
  useEffect,
  useState,
} from 'react'

import HtmlForm from './styles'

import { Props } from './types'

const Form: React.FC<Props> = ({
  finalFormApi,
  ...props
}): React.ReactElement => {
  const [
    isReady,
    setIsReady,
  ] = useState(false)
  const [
    inputToFocus,
    setInputToFocus,
  ] = useState(undefined)

  if (finalFormApi !== undefined) {
    const formIsInited = !!finalFormApi.getRegisteredFields().length && !finalFormApi.getState().validating
    const firstInvalidInput = (formIsInited && finalFormApi.getRegisteredFields().find((field: string) => finalFormApi.getFieldState(field).invalid)) || undefined

    if (formIsInited && !isReady) {
      setIsReady(true)
    }

    if (firstInvalidInput && !inputToFocus) {
      setInputToFocus(firstInvalidInput)
    }
  }

  useEffect(() => {
    if (!isReady) {
      return
    }

    const targetInput = document.querySelector(`form ${inputToFocus ? `[name="${inputToFocus}"]` : 'input:first-child'}`) as HTMLElement
    if (targetInput) {
      targetInput.focus({ preventScroll: true })
    }
  }, [ isReady ]) // eslint-disable-line react-hooks/exhaustive-deps

  return <HtmlForm {...props} />
}

export default Form
